<mat-toolbar class="mat-primary">
  <span class="fill-remaining-space">Personalisierung anpassen</span>
  <mat-icon class="cursor-mat-element" (click)="onCancel()">close</mat-icon>
</mat-toolbar>
<mat-dialog-content>
  <ng-container *ngIf="permissions$ | async as permissions">
    <ng-container *ngIf="pageConfigsForm$ | async as pageConfigsForm">
      <ng-container *ngIf="generalPagePreferencesForm$ | async as generalPagePreferencesForm">
        <h2>Seitenkonfigurationen</h2>
        <form>
          <form-row>
            <mat-form-field appearance="outline" fxFlex="40">
              <mat-label>Anzahl Einträge pro Seite</mat-label>
              <input matInput type="number" [formControl]="generalPagePreferencesForm.controls.listSize" />
              <mat-error
                *ngIf="
                  generalPagePreferencesForm.controls.listSize.touched &&
                  generalPagePreferencesForm.controls.listSize.hasError('min')
                ">
                Bitte geben Sie eine Zahl größer als 10 ein.
              </mat-error>
              <mat-error
                *ngIf="
                  generalPagePreferencesForm.controls.listSize.touched &&
                  generalPagePreferencesForm.controls.listSize.hasError('max')
                ">
                Bitte geben Sie eine Zahl kleiner als 50 ein.
              </mat-error>
              <mat-error
                *ngIf="
                  generalPagePreferencesForm.controls.listSize.touched &&
                  generalPagePreferencesForm.controls.listSize.hasError('required')
                ">
                Bitte geben Sie eine Zahl ein.
              </mat-error>
            </mat-form-field>
            <p>
              Eine geringere Anzahl an Einträgen pro Seite führt zu einem schnelleren Laden der Liste.
              (mindestens 10, maximal 50 Einträge)
            </p>
          </form-row>
        </form>
        <form>
          <mat-checkbox
            [(ngModel)]="allPagesV2Selected"
            [checked]="isAllPagesV2Selected$(pageConfigsForm) | async"
            (change)="onToggleAllPages($event.checked, pageConfigsForm)">
            Neue Listen für
            <strong>alle Seiten</strong>
            verwenden
          </mat-checkbox>
          <div style="margin-left: 2rem">
            <app-string-checkbox
              *ngIf="permissions.orderRequest"
              [formControl]="pageConfigsForm.controls['order-request'].controls.pageVersion"
              [trueValue]="'v2'"
              [falseValue]="'v1'">
              Neue Liste für
              <strong>Hausanschlüsse</strong>
              verwenden
            </app-string-checkbox>
            <app-string-checkbox
              *ngIf="permissions.installerPass"
              [formControl]="pageConfigsForm.controls['admin-installer-pass'].controls.pageVersion"
              [trueValue]="'v2'"
              [falseValue]="'v1'">
              Neue Liste für
              <strong>Ausweise</strong>
              verwenden
            </app-string-checkbox>
            <app-string-checkbox
              *ngIf="permissions.installer || permissions.commissioning"
              [formControl]="pageConfigsForm.controls['commissioning-request'].controls.pageVersion"
              [trueValue]="'v2'"
              [falseValue]="'v1'">
              Neue Liste für
              <strong>Inbetriebnahmen</strong>
              verwenden
            </app-string-checkbox>
            <app-string-checkbox
              *ngIf="permissions.installer || permissions.gridRegistration"
              [formControl]="pageConfigsForm.controls['grid-registration'].controls.pageVersion"
              [trueValue]="'v2'"
              [falseValue]="'v1'">
              Neue Liste für
              <strong>Netzanmeldungen</strong>
              verwenden
            </app-string-checkbox>
            <app-string-checkbox
              *ngIf="permissions.feederContract"
              [formControl]="pageConfigsForm.controls['feeder-contract'].controls.pageVersion"
              [trueValue]="'v2'"
              [falseValue]="'v1'">
              Neue Liste für
              <strong>Einspeiserverträge</strong>
              verwenden
            </app-string-checkbox>
          </div>
        </form>

        <div class="button-container">
          <button mat-stroked-button color="primary" (click)="onCancel()">Abbrechen</button>
          <button
            mat-raised-button
            (click)="onConfirm(pageConfigsForm, generalPagePreferencesForm)"
            color="primary">
            Speichern
          </button>
        </div>
      </ng-container>
    </ng-container>
  </ng-container>
</mat-dialog-content>
